<template>
	<BasicLayout :left="left" :middle="middle" :right="right">
		<template v-slot:right_view>
			<div class="h100-100">
				<div class="h-scroll h-wrapper-680">
					<div class="h-dialogContainer">
						<form id="mapConfigForm">
							<div class="row h-row-inputBox">
								<div class="form-group h-col-inputBox">
									<div class="e-float-input">
										<div class="h-inputLit">{{$t('System.maxLayer')}}</div>
										<div class="e-input-group e-control-wrapper">
											<input :placeholder="$t('System.input1t15')" id="maxLayer" name="MaxLayer" v-model="maxLayer" />
										</div>
									</div>
								</div>
								<div class="form-group h-col-inputBox">
									<div class="e-float-input">
										<div class="h-inputLit">{{$t('System.minLayer')}}</div>
										<div class="e-input-group e-control-wrapper">
											<input :placeholder="$t('System.input1t15')" id="minLayer" name="MinLayer" v-model="minLayer" />
										</div>
									</div>
								</div>
								<div class="form-group h-col-inputBox">
									<div class="e-float-input">
										<div class="h-inputLit">{{$t('System.defaultLayer')}}</div>
										<div class="e-input-group e-control-wrapper">
											<input :placeholder="$t('System.input1t15')" id="defaultLayer" name="DefaultLayer" v-model="defaultLayer" />
										</div>
									</div>
								</div>
								<div class="form-group h-col-inputBox">
									<div class="e-float-input">
										<div class="h-inputLit">{{$t('System.centerLon')}}</div>
										<div class="e-input-group e-control-wrapper">
											<input :placeholder="$t('System.centerLonInput')" id="centerLon" name="CenterLon" v-model="centerLon" />
										</div>
									</div>
								</div>
								<div class="form-group h-col-inputBox">
									<div class="e-float-input">
										<div class="h-inputLit">{{$t('System.centerLat')}}</div>
										<div class="e-input-group e-control-wrapper">
											<input :placeholder="$t('System.centerLatInput')" id="centerLat" name="CenterLat" v-model="centerLat" />
										</div>
									</div>
								</div>
								<div class="form-group h-col-inputBox">
									<div class="e-float-input">
										<div class="h-inputLit">{{$t('System.copyright')}}</div>
										<div class="e-input-group e-control-wrapper">
											<input :placeholder="$t('System.copyrightInput')" id="copyright" name="Copyright" v-model="copyright" />
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
        <div class="b-t"></div>
        <div class="h-scroll h-system-wrapper-680">
          <div class="h-bottom-btnBox h-system-btnBox">
            <div class="row">
              <div class="col-sm-12 h-col-inputBox">
                <ejs-button cssClass="e-control e-btn e-lib e-flat" @click.native="resetMap">{{$t('System.reset')}}</ejs-button>
                <ejs-button cssClass="e-control e-btn e-lib e-flat" @click.native="clearMap">{{$t('Alarm.clear')}}</ejs-button>
                <ejs-button cssClass="e-control e-btn e-lib e-primary e-flat" @click.native="saveMap">{{$t('System.save')}}</ejs-button>
              </div>
            </div>
          </div>
        </div>
			</div>
		</template>
	</BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import mixin from '../../mixin/mixin';
import {EventBus} from "../../plugins/eventBus";
export default {
	name: 'MapConfig',
	mixins: [mixin],
	components: {
		BasicLayout,
	},
	data() {
		return {
			left: { show: false, name: "" },
			middle: { show: false, name: "" },
			right: {
				show: true,
				crumb: `${this.$t('System.systemManager')}/${this.$t("System.systemSet")}/${this.$t("System.mapConfig")}`
			},
			maxLayer: '',
			minLayer: '',
			defaultLayer: '',
			centerLon: '',
			centerLat: '',
			copyright: '',
			formObj: '',
			inputNames: ['MaxLayer', 'MinLayer', 'DefaultLayer', 'CenterLon', 'CenterLat', 'Copyright'],
			rules: {
				MaxLayer: { required: true, number: true, range: [1, 15], regex: 'integer'},
				MinLayer: { required: true, number: true, range: [1, 15], regex: 'integer'},
				DefaultLayer: { required: true, number: true, range: [1, 15], regex: 'integer'},
        CenterLon: { required: true, regex:'longitude' },
        CenterLat: { required: true, regex:'latitude' },
				Copyright: { required: true, maxLength: 225 }
			}
		}
	},
	methods: {
		  async resetMap() {
      await this.getMapConfig();
      Object.keys(this.rules).forEach((item) =>{
        let id = item+"-info";
        if(document.getElementById(id)){
          document.getElementById(id).style.display = "none" ;
        }
      })
    },
		clearMap() {
			this.maxLayer = '';
			this.minLayer = '';
			this.defaultLayer = '';
			this.centerLon = '';
			this.centerLat = '';
			this.copyright = '';
			this.mapCfgId = '';
		},
		saveMap() {
			const status = this.formObj.validate();
			if (!status) {
				return null;
			}
			const url = '/lte/ems/sysmanager/map/saveConfig';
			const params = {
				centerLatitude: this.centerLat,
				centerLongitude: this.centerLon,
				defaultZoom: this.defaultLayer,
				mapPrefix: this.copyright,
				maxZoom: this.maxLayer,
				minZoom: this.minLayer
			};
			this.axios.post(url, params).then(response => {
				if (response.data) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('System.saveMapSuccess')});
				}
			});
		},
		getMapConfig() {
			const url = '/lte/ems/sysmanager/map/queryConfig';
			this.axios.post(url).then(response => {
				const result = response.data;
				this.maxLayer = result['maxZoom'],
				this.minLayer = result['minZoom'],
					this.defaultLayer = result['defaultZoom'],
					this.centerLon = result['centerLongitude'],
					this.centerLat = result['centerLatitude'],
					this.copyright = result['mapPrefix']
			});
		}
	},
	mounted() {
		this.formObj = this.validateForm('mapConfigForm', this.inputNames, this.rules);
		this.getMapConfig();
	}
}
</script>

